import PreviewDetailImg from 'assets/images/feature-slots/preview_detail.png';
import PreviewListImg from 'assets/images/feature-slots/preview_list.png';
import { SLOT_KEY, getRouteName } from './common';

const MODULE_NAME = 'Setting';

const routes = [
	{
		matchRegex: '/Library',
		name: getRouteName(MODULE_NAME, 'Library'),
		slots: [SLOT_KEY.SLOT_LIST_GRID, SLOT_KEY.SLOT_SCRIPTS]
	},
	{
		matchRegex: '/Library/Misc',
		name: getRouteName(MODULE_NAME, 'Misc'),
		slots: [SLOT_KEY.SLOT_LIST_GRID, SLOT_KEY.SLOT_V_SECTION],
		image: PreviewListImg,
		parentKeys: {
			[SLOT_KEY.SLOT_V_SECTION]: [{ key: 'page-additional-menu-action', label: 'Page Additional Menu Action' }]
		}
	}
];

export default routes;
